import * as React from 'react'
import { FastField } from 'formik'

import { MuiTextFieldFormik } from '@user/components/Formik'
import { SoldServiceAppDataDropdown } from '@user/store/opportunity'

import { useGetCustomFieldProps } from '../hooks'

import MenuItem from '@mui/material/MenuItem'

type Props = {
  disabled: boolean
  appData: SoldServiceAppDataDropdown
}

export function DropdownField(props: Props) {
  const { appData, disabled } = props

  const { values, caption, required } = appData

  const fieldProps = useGetCustomFieldProps(appData)

  return (
    <FastField
      {...fieldProps}
      component={MuiTextFieldFormik}
      disabled={disabled}
      select
    >
      {!required && <MenuItem value="">Select {caption}</MenuItem>}

      {values.map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      ))}
    </FastField>
  )
}
